import React from "react";
import Root from "../layout/Root";
import './Withdraw.scss';
import {RouteComponentProps} from "react-router-dom";
import {t} from "../i18n";
import {EntryCollection} from "contentful";
import {ContentModelName, GlobalPayload} from "../contenful/types";
import {AppState} from "../RootReducer";
import {fetchContent} from "../contenful/ContentfulActions";
import {Dispatch} from "redux";
import {connect} from "react-redux";
import Markdown from 'react-markdown'
import {setCountryIsBlocked} from "../settings/SettingsActions";


interface PropsFromState {
    global?:GlobalPayload;
}

type AllProps = RouteComponentProps<{country : string}> & PropsFromDispatch & PropsFromState;

export class CountryBlocked extends React.Component<AllProps, { entries? :EntryCollection<any>, loading? : boolean }> {
    constructor(props : AllProps) {
        super(props);
        this.state = {
            loading : true,
        }
    }

    componentDidMount(): void {
        this.props.setBlockedCountry(true);
        if(this.props.global === undefined) {
            this.props.fetchContent(ContentModelName.GLOBAL);
        }
    }

    render() {
        let title = t("country-block.title", { country : this.props.match.params.country});
        const {global} = this.props;

        return (
            <React.Fragment>
                <Root footer={false} className={"country-blocked-page"}>
                    <div className={"country-blocked-container"}>
                        <h1 className={"country-blocked-title"}>{title}</h1>
                        {global && global.blockedCountryText && <div className={"country-blocked-text"}><Markdown children={global.blockedCountryText} /></div>}
                    </div>
                </Root>
            </React.Fragment>
        )
    }
}

interface PropsFromDispatch {
    fetchContent: typeof fetchContent;
    setBlockedCountry: typeof setCountryIsBlocked;
}
const mapStateToProps = ({contentful} : AppState) => {
    return {
        global: contentful.global,
    }
}
const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
        fetchContent: (contentModelName: ContentModelName, locale?: string) => dispatch(fetchContent(contentModelName, locale) as any),
        setBlockedCountry: (isBloacked: boolean) => dispatch(setCountryIsBlocked(isBloacked))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CountryBlocked as any)



